import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UserActions from "src/reducers/userReducer";
import { DeviceAPI } from "src/api";
import { styles } from "src/styles";
import { IDevice } from "src/api/devices";

interface IDeviceSettingsTabProps {
  device: IDevice;
  location: any;
  userActions: any;
  userState: any;
  userId: any;
}

interface IDeviceSettingsTabState {
  loading: boolean;
  settings: any;
}

class DeviceSettingsTab extends Component<IDeviceSettingsTabProps, IDeviceSettingsTabState> {
  constructor(props: IDeviceSettingsTabProps) {
    super(props);

    this.state = {
      loading: false,
      settings: ""
    };

    this.updateField = this.updateField.bind(this);
    this.getSettings = this.getSettings.bind(this);
  }

  updateField(e: any) {
    let ns: any = this.state;
    ns[e.target.id] = e.target.value;
    this.setState(ns);
  }

  componentDidMount() {
    this.getSettings();
  }

  getSettings() {
    this.setState({ loading: true }, async () => {
      try {
        const res = await DeviceAPI.getSettingsForDevice(
          "wagz",
          this.props.userId,
          this.props.device.id
        );
        this.setState({
          loading: false,
          settings: res.body.data,
        });
      } catch (err) {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    return (
      <div>
        <div style={styles.shadowBox}>
          <div style={{ margin: 10 }}>
            <h4>Device Settings</h4>
            <pre>{JSON.stringify(this.state.settings, null, 2)}</pre>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function map(s: any) {
  return {
    userState: s.userState,
  };
};

function mapDispatchToProps(dispatch: any) {
  return {
    userActions: bindActionCreators(UserActions, dispatch),
  };
}

export default connect<{}, {}, any>(
  mapStateToProps,
  mapDispatchToProps
)(DeviceSettingsTab);
